import React from 'react';
import { Link, graphql, navigate, withPrefix } from 'gatsby';
import Layout from '../components/Layout';
import Newsletter from '../components/Newsletter';
import Footer from '../components/Footer';
import Navigation from '../components/Navigation';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

const ImpressumPage = ({ pageContext: { locale }, ...props }) => {
  const { node: data } = props.data.ImpressumPageData.edges[0]
  return (
      <Layout>
        <Helmet>
          <html lang='de' /> 
          <title>Impressum - presono</title>
          <meta
            name="description"
            content="Impressum der presono GmbH - Planung, Konzeption, Umsetzung und Vertrieb einer Softwarelösung sowie von Projekten im Bereich Multimedia und Beratung, einschließlich aller damit einhergehenden Tätigkeiten."
          />
        </Helmet>
        <Navigation langSwitch={data.frontmatter.langSwitch} locale={locale} />
        <section>
          <div className="container">
            <div className="columns secondarypage impressum">
              <div className="columns is-12">
                <div className="row" id="row-1515269463">
                  <div className="col small-12 large-12">
                    <div className="col-inner">

                        <div className="headliner top starfield b1 t1 pusher">
                          <h1>Impressum <small> der presono GmbH </small></h1>
                        </div>

                        <div className="blogpage">
                          <div className="blog-content">
                              <div className="container">
                                <p>Unternehmensgegenstand: Planung, Konzeption, Umsetzung und Vertrieb einer Softwarelösung sowie von Projekten im Bereich Multimedia und Beratung, einschließlich aller damit einhergehenden Tätigkeiten.</p>
                                <p>Sitz: Landstrasse 15, A-4020 Linz
                                  <br /> Tel.: +43 650 - 980 80 35
                                  <br /> Email: <a href="mailto:info@presono.com">info@presono.com</a>
                                  <br /> UID-Nr.: ATU70989424
                                  <br /> Firmenbuchnr.: FN 452857 t
                                  <br /> Gerichtsstand Linz
                                  <br /> Mitglied der Wirtschaftskammer Oberösterreich
                                </p>
                                <p>Berufsrecht Gewerbeordnung <a href="http://www.ris.bka.gv.at/" target="_blank" rel="noopener">http://www.ris.bka.gv.at/</a></p>
                                <p>Aufsichtbehörde: Behörde gem. ECG (E-Commerce Gesetz): Magistrat der Stadt Linz/Donau</p>
                                <p>Handelsrechtliche Geschäftsführer: Martin Behrens BSc</p>
                                <p>Gewerberechtliche Geschäftsführer: Martin Behrens BSc</p>
                                <p><a href="https://presono.com">www.presono.com</a></p>
                                <p>Diese Website dient der Information über die Dienstleistungen und Angebote des oben angeführten Unternehmens sowie der Förderung des Absatzes derselben.</p>
                            </div>
                          </div>
                        </div>
                      </div>
                   </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Newsletter newsletter={data.frontmatter} locale={locale} />
        <Footer locale={locale} />
      </Layout>
  )
}

export default ImpressumPage;

ImpressumPage.propTypes = {
  data: PropTypes.shape({
    allMarkdownRemark: PropTypes.shape({
      edges: PropTypes.array,
    }),
  }),
}

export const pageQuery = graphql`
query ImpressumContent($locale: String) {
  ImpressumPageData: allMarkdownRemark(
    filter: {frontmatter: { pageKey: {eq: "page_impressum"}, locale: { eq: $locale }}}
  ) {
    edges {
      node {
        fields {
          slug
        }
        frontmatter {
          pageKey
          langSwitch
        }
      }
    }
  }
}
`
